export default __webpack_public_path__ + "static/media/wing-pattern.c47d602f.svg";